import { Norm, User } from '../../types/user.ts';
import { UserState } from '../reducers/user.reducer.ts';
import { RootState } from '../store.ts';

const getUserState = (state: RootState): UserState => state.user;
export const getUser = (state: RootState): User | undefined => state.user.user;
export const getIsLoadingUser = (state: RootState): boolean => getUserState(state).isLoadingUser;
export const getLoginError = (state: RootState): boolean => getUserState(state).loginError;
export const getRegisterErrorMessage = (state: RootState): string => getUserState(state).registerErrorMessage;
export const getSearchQuery = (state: RootState): string => getUserState(state).searchQuery;
export const getResetPasswordRequestSent = (state: RootState): boolean => getUserState(state).resetPasswordRequestSent;
export const getProfilePictureUrl = (state: RootState): string | undefined => getUserState(state).profilePictureUrl;
export const getNorms = (state: RootState): Norm[] => getUserState(state).norms;
export const getIsImpersonating = (state: RootState): boolean => getUserState(state).isImpersonating;
export const getIsSendingInvitation = (state: RootState): boolean => getUserState(state).isSendingInvitation;
export const getInvitationSuccess = (state: RootState): boolean => getUserState(state).invitationSuccess;
export const getIsSendingCredits = (state: RootState): boolean => getUserState(state).isSendingCredits;
export const getCreditsSuccess = (state: RootState): boolean => getUserState(state).creditsSuccess;
export const getIsCopyingProject = (state: RootState): boolean => getUserState(state).isCopyingProject;
export const getCopiedProject = (state: RootState) => getUserState(state).copiedProject;
export const getAllUsers = (state: RootState): User[] => getUserState(state).allUsers;
